import styled from 'styled-components';

import Alert from '../alert/Alert';
import Link from '../link/Link';
import Typography from '../typography/Typography';

// Halfway between the alert's background (#EEF2FA) and the blue the action severity would
// otherwise use for the border (#339DFF), which reads as too heavy on a small snackbar.
const BORDER_COLOR = '#90C7FC';

// Fixed, so the snackbar does not resize on every tick of the countdown. The content measures
// 325px, and the content is centred so the slack sits evenly on both sides.
const WIDTH = '340px';

interface Props {
  secondsUntilReload: number;
  onReloadNow: () => void;
}

const AppUpdateSnackbar = (props: Props) => {
  const { secondsUntilReload, onReloadNow } = props;

  return (
    <Container data-testid="app-update-snackbar">
      <Alert severity="action" padding="8px 16px" width={WIDTH} borderColor={BORDER_COLOR} justifyContent="center">
        <Row>
          <Typography variant="span">{`Ny version - opdaterer om ${secondsUntilReload} sek`}</Typography>
          <Link onClick={onReloadNow}>Opdater nu</Link>
        </Row>
      </Alert>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  bottom: ${(props) => props.theme.spacing(3)};
  left: 50%;
  transform: translateX(-50%);
  z-index: ${(props) => props.theme.zIndex.toast};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${(props) => props.theme.spacing(2)};
  white-space: nowrap;
`;

export default AppUpdateSnackbar;
